import { _ as ma } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.every-3d11adb5.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.from-fe752fa6.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.function.name-b230e7d4.js";
import "./es.array.some-0c761b6d.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.iterator-5de8a61e.js";
import "./index-5d0f31c6.js";
import { c as te } from "./index-8b07dec9.js";
import { useMemo as Pe, useRef as ee, useEffect as ne } from "react";
import N, { css as x } from "styled-components";
import { ScreenReaderOnly as ha } from "./screenReaderOnly.js";
import { i as Be, e as Ae, j as ye, k as $, g as Le, b as Te, d as Ee, T as va, l as ya, M as ga, m as Sa } from "./localeLanguages-75ceae62.js";
import "./es.array.index-of-084b82ab.js";
import "./es.string.replace-f4cc3aea.js";
import { jsxs as re, jsx as _ } from "react/jsx-runtime";
import "./web.set-timeout-72b6430f.js";
import { useCustomTranslation as pa } from "@ucl/ucl-translation";
import { Button as fa } from "./button.js";
import { IconButton as Ca } from "./iconButton.js";
var Da = function(e) {
  e === void 0 && (e = "en_US");
  var r = typeof e == "string" ? Be(e) : e, i = r.months, m = r.getToday, n = r.toNativeDate, d = r.getMonthLength, g = r.weekStartingIndex, h = r.transformDigit, c = function() {
    var s = /* @__PURE__ */ new Date(), p = s.getFullYear(), D = s.getMonth() + 1, f = s.getDate();
    return m({
      year: p,
      month: D,
      day: f
    });
  }, S = function(s) {
    return i[s - 1];
  }, j = function(s) {
    return i.indexOf(s) + 1;
  }, R = function(s) {
    var p = n(Object.assign({}, s, {
      day: 1
    })), D = p.getDay(), f = D + g;
    return f % 7;
  }, W = function(s, p) {
    return !s || !p ? !1 : n(s) < n(p);
  }, I = function(s) {
    var p = s.day, D = s.from, f = s.to;
    if (!p || !D || !f)
      return !1;
    var P = n(p), L = n(D), z = n(f);
    return P > L && P < z;
  };
  return {
    getToday: c,
    getMonthName: S,
    getMonthNumber: j,
    getMonthLength: d,
    getMonthFirstWeekday: R,
    isBeforeDate: W,
    checkDayInDayRange: I,
    getLanguageDigits: h
  };
}, pe = function(e) {
  return Pe(function() {
    return Da(e);
  }, [e]);
}, Ve = function(e) {
  return Pe(function() {
    return Be(e);
  }, [e]);
}, Ce = function(e, r) {
  return e ? e.children[r] : null;
}, ge = function(e) {
  return e && (e.hasAttribute("aria-hidden") ? null : e);
}, Se = function(e, r) {
  e.preventDefault(), r && (r.setAttribute("tabindex", "0"), r.focus());
}, Re = function(e, r) {
  return Ce(r, Array.from(e.parentElement.children).indexOf(e));
}, be = function(e, r) {
  var i = r.allowVerticalArrows, m = document, n = m.activeElement, d = n.parentElement, g = d.nextSibling, h = d.previousSibling, c = ge(n.nextSibling || Ce(g, 0)), S = h ? h.children.length - 1 : 0, j = ge(n.previousSibling || Ce(h, S)), R = ge(Re(n, g)), W = ge(Re(n, h)), I = n.dataset.isDefaultSelectable === "true";
  switch (I || (n.tabIndex = "-1"), e.code) {
    case "ArrowRight":
      Se(e, c);
      break;
    case "ArrowLeft":
      Se(e, j);
      break;
    case "ArrowDown":
      i && Se(e, R);
      break;
    case "ArrowUp":
      i && Se(e, W);
      break;
  }
}, je = function(e) {
  var r = e.parent, i = e.isInitialActiveChild, m = e.activeDate, n = e.monthChangeDirection;
  if (!r)
    return i ? m : Ae(m, "NEXT");
  var d = r.children[i ? 0 : 1], g = d.classList.contains("-shown") || d.classList.contains("-shownAnimated");
  return g ? m : Ae(m, n);
}, Ke = function(e) {
  var r = e.parent, i = e.direction, m = Array.from(r.children), n = m.find(function(c) {
    return c.classList.contains("-shown");
  }), d = m.find(function(c) {
    return c !== n;
  }), g = i === "NEXT", h = function(S) {
    return S ? "-hiddenNext" : "-hiddenPrevious";
  };
  d.style.transition = "none", n.style.transition = "", n.classList.remove(h(g)), n.classList.add(h(!g)), n.classList.remove("-shown"), n.setAttribute("aria-hidden", "true"), d.classList.remove(h(!g)), d.classList.add(h(g)), d.classList.add("-shownAnimated");
}, De = function(e) {
  var r = e.target;
  r.classList.remove("-hiddenNext"), r.classList.remove("-hiddenPrevious"), r.classList.replace("-shownAnimated", "-shown"), r.setAttribute("aria-hidden", "false");
}, ba = ["isDisabled"], ka = /* @__PURE__ */ N.div.withConfig({
  displayName: "DaysList__StyledCalendarSectionWrapper",
  componentId: "sc-16bdbdk-0"
})(["&.Calendar__sectionWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSectionWrapper);
}), We = /* @__PURE__ */ N.div.withConfig({
  displayName: "DaysList__StyledCalendarSection",
  componentId: "sc-16bdbdk-1"
})(["&.Calendar__section{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSection);
}), _a = /* @__PURE__ */ N.div.withConfig({
  displayName: "DaysList__StyledCalendarDay",
  componentId: "sc-16bdbdk-2"
})(["&.Calendar__day{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarDay);
}), Ma = /* @__PURE__ */ N.div.withConfig({
  displayName: "DaysList__StyledCalendarWeekRow",
  componentId: "sc-16bdbdk-3"
})(["&.Calendar__weekRow{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarWeekRow);
}), mt = function(e) {
  var r = e.activeDate, i = e.value, m = e.monthChangeDirection, n = e.onSlideChange, d = e.disabledDays, g = d === void 0 ? [] : d, h = e.onDisabledDayError, c = e.minimumDate, S = e.maximumDate, j = e.onChange, R = e.locale, W = e.calendarTodayClassName, I = W === void 0 ? "" : W, M = e.calendarSelectedDayClassName, s = M === void 0 ? "" : M, p = e.calendarRangeStartClassName, D = p === void 0 ? "" : p, f = e.calendarRangeEndClassName, P = f === void 0 ? "" : f, L = e.calendarRangeBetweenClassName, z = L === void 0 ? "" : L, K = e.shouldHighlightWeekends, q = K === void 0 ? !1 : K, T = e.isQuickSelectorOpen, X = e.customDaysClassName, Q = e.includeOutOfMonthDays, H = e.selectorStartingYear, F = e.selectorEndingYear, oe = e.allowedDates, J = e.weekendDisabled, v = e.textMarkers, C = ee(null), b = Ve(R), E = b.isRtl, Y = b.weekDays, B = pe(R), ce = B.getToday, Z = B.isBeforeDate, se = B.checkDayInDayRange, ue = B.getMonthFirstWeekday, ie = B.getMonthLength, He = B.getLanguageDigits, Ue = B.getMonthName, me = ce();
  ne(function() {
    m && Ke({
      direction: m,
      parent: C.current
    });
  }, [m]);
  var $e = function(a) {
    var l = ya(i), o = l.from && l.to ? {
      from: null,
      to: null
    } : l, u = o.from ? "to" : "from";
    o[u] = a;
    var k = o.from, y = o.to;
    Z(o.to, o.from) && (o.from = y, o.to = k);
    var w = function(U) {
      return se({
        day: U,
        from: o.from,
        to: o.to
      });
    }, O = g.find(w);
    return O ? (h == null || h(O), i) : o;
  }, Fe = function(a) {
    var l = i.some(function(k) {
      return $(k, a);
    }), o = [].concat(i, [a]), u = i.filter(function(k) {
      return !$(k, a);
    });
    return l ? u : o;
  }, qe = function(a) {
    var l = function() {
      var k = Le(i);
      switch (k) {
        case Te:
          return a;
        case va:
          return $e(a);
        case Ee:
          return Fe(a);
      }
    }, o = l();
    j == null || j(o);
  }, Xe = function(a) {
    var l = Le(i);
    if (l === Te)
      return $(a, i);
    if (l === Ee)
      return i.some(function(o) {
        return $(o, a);
      });
  }, ke = function(a) {
    var l = $(a, me), o = Xe(a), u = i || {}, k = u.from, y = u.to, w = $(a, k), O = $(a, y), A = se({
      day: a,
      from: k,
      to: y
    });
    return {
      isToday: l,
      isSelected: o,
      isStartingDayRange: w,
      isEndingDayRange: O,
      isWithinRange: A
    };
  }, Ge = function(a) {
    var l = ke(a), o = l.isToday, u = l.isSelected, k = l.isStartingDayRange, y = l.isEndingDayRange, w = l.isWithinRange, O = X == null ? void 0 : X.find(function(U) {
      return $(a, U);
    }), A = "".concat(o && !u ? " -today " + I : "").concat(a.isStandard ? "" : " -blank").concat(a.isWeekend && q ? " -weekend" : "").concat(a.outOfMonth ? " -outofmonth" : "").concat(O ? " " + O.className : "").concat(u ? " -selected " + s : "").concat(k ? " -selectedStart " + D : "").concat(y ? " -selectedEnd " + P : "").concat(w ? " -selectedBetween " + z : "").concat(a.isDisabled ? " -disabled" : "");
    return A;
  }, ze = function(a) {
    var l = ye(ue(a), "starting-blank"), o = ye(ie(a), void 0).map(function(U) {
      return Object.assign({}, U, {
        isStandard: !0,
        month: a.month,
        year: a.year
      });
    });
    if (Q) {
      var u = Object.assign({}, a, {
        month: a.month - 1
      });
      u.month < 1 && (u.month = 12, u.year -= 1);
      var k = ue(a) === 0 ? [] : ye(ie(u), void 0).map(function(U) {
        return Object.assign({}, U, {
          outOfMonth: !0,
          isStandard: !0,
          month: u.month,
          year: u.year
        });
      }).slice(-ue(a)), y = Object.assign({}, a, {
        month: a.month + 1
      });
      y.month > 12 && (y.month = 1, y.year += 1);
      var w = ye(ie(y), void 0).map(function(U) {
        return Object.assign({}, U, {
          outOfMonth: !0,
          isStandard: !0,
          month: y.month,
          year: y.year
        });
      }).slice(0, 42 - (k.length + o.length)), O = [].concat(k, o, w);
      return O;
    }
    var A = [].concat(l, o);
    return A;
  }, _e = function(a) {
    var l = a.isDisabled, o = ma(a, ba);
    l ? h == null || h(o) : qe(o);
  }, Qe = function(a) {
    var l = a.isOnActiveSlide, o = a.isStandard, u = a.isSelected, k = a.isStartingDayRange, y = a.isToday, w = a.day;
    if (T || !l || !o)
      return !1;
    if (u || k || y || w === 1)
      return !0;
  }, Je = function(a, l) {
    var o = a.id, u = a.value, k = a.month, y = a.year, w = a.isStandard, O = a.outOfMonth, A = {
      day: u,
      month: k,
      year: y
    }, U = !1;
    oe && oe.some(function(G) {
      return $(A, G);
    }) && (U = !0);
    var ea = g.some(function(G) {
      return $(A, G);
    }), aa = Z(A, c), ta = Z(S, A), na = y < H || y > F, ra = w && (aa || ta || na), we = Y.some(function(G, de) {
      return G.isWeekend && de === l;
    }), he = oe ? !U : ea || ra || we && J, oa = Ge(Object.assign({}, A, {
      isWeekend: we,
      isStandard: w,
      isDisabled: he,
      outOfMonth: O
    })), Ne = Y[l].name + ", " + u + " " + Ue(k) + " " + y, xe = k === r.month, le = ke(A), ia = le.isSelected, la = le.isStartingDayRange, da = le.isEndingDayRange, ca = le.isWithinRange, Ye = Qe(Object.assign({}, A, le, {
      isOnActiveSlide: xe,
      isStandard: w
    })), ve = new Date(Ne), sa = function() {
      var de = ve.getFullYear(), fe = ve.getMonth() + 1, ua = ve.getDate();
      return me.year === de && me.month === fe && me.day === ua;
    }, ae = v == null ? void 0 : v.find(function(G) {
      return G.date.valueOf() === ve.valueOf();
    });
    return /* @__PURE__ */ re(_a, Object.assign({
      tabIndex: Ye && !O ? 0 : -1,
      className: te(["Calendar__day", E ? "-rtl" : "-ltr", {
        "-text": !!ae
      }, ae != null && ae.variant ? "-" + ae.variant : "-outlined", oa]),
      onClick: function() {
        _e(Object.assign({}, A, {
          isDisabled: he
        }));
      },
      onKeyDown: function(de) {
        var fe = de.key;
        fe === "Enter" && _e(Object.assign({}, A, {
          isDisabled: he
        }));
      },
      "aria-disabled": he
    }, sa() && {
      "aria-current": "date"
    }, {
      "aria-selected": ia || la || da || ca
    }, !w || !xe || T ? {
      "aria-hidden": !0
    } : {}, {
      role: "gridcell",
      "data-is-default-selectable": Ye,
      children: [w && /* @__PURE__ */ re("div", {
        "aria-hidden": !0,
        children: [/* @__PURE__ */ _("span", {
          children: He(u)
        }), (ae == null ? void 0 : ae.text) && /* @__PURE__ */ _("span", {
          className: "Calendar__day--text-marker",
          children: ae.text.slice(0, 5)
        })]
      }), /* @__PURE__ */ _(ha, {
        children: Ne
      })]
    }), o);
  }, Me = function(a) {
    var l = je({
      activeDate: r,
      isInitialActiveChild: a,
      monthChangeDirection: m,
      parent: C.current
    }), o = ze(l), u = function(y) {
      var w = o.slice(y * 7, y * 7 + 7).map(Je), O = w.every(function(A) {
        return A.props["data-is-default-selectable"] === !1;
      });
      return w.length > 0 ? /* @__PURE__ */ _(Ma, {
        className: "Calendar__weekRow",
        role: O ? "presentation" : "row",
        children: w
      }, String(y)) : "";
    };
    return Array.from(Array(6).keys()).map(u);
  }, Ze = function(a) {
    be(a, {
      allowVerticalArrows: !0
    });
  };
  return /* @__PURE__ */ re(ka, {
    ref: C,
    className: "Calendar__sectionWrapper",
    role: "presentation",
    "data-testid": "days-section-wrapper",
    onKeyDown: Ze,
    children: [/* @__PURE__ */ _(We, {
      onAnimationEnd: function(a) {
        De(a), n();
      },
      className: "Calendar__section -shown",
      role: "rowgroup",
      children: Me(!0)
    }), /* @__PURE__ */ _(We, {
      onAnimationEnd: function(a) {
        De(a), n();
      },
      className: "Calendar__section -hiddenNext",
      "aria-hidden": !0,
      role: "rowgroup",
      children: Me(!1)
    })]
  });
}, wa = /* @__PURE__ */ N.div.withConfig({
  displayName: "Header__StyledCalenderHeader",
  componentId: "sc-16xnavx-0"
})(["&.Calendar__header{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalenderHeader);
}), Ie = /* @__PURE__ */ N(Ca).withConfig({
  displayName: "Header__StyledIconButton",
  componentId: "sc-16xnavx-1"
})(["&.Calendar__header-iconButton{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledIconButton);
}), Na = /* @__PURE__ */ N.div.withConfig({
  displayName: "Header__StyledMonthYearContainer",
  componentId: "sc-16xnavx-2"
})(["&.Calendar__header-monthYearContainer{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledMonthYearContainer);
}), xa = /* @__PURE__ */ N.div.withConfig({
  displayName: "Header__StyledMonthYearWrapper",
  componentId: "sc-16xnavx-3"
})(["&.Calendar__header-monthYearWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledMonthYearWrapper);
}), Oe = /* @__PURE__ */ N(fa).withConfig({
  displayName: "Header__StyledButton",
  componentId: "sc-16xnavx-4"
})(["&.Calendar__header-Button{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledButton);
}), ht = function(e) {
  var r = e.maximumDate, i = e.minimumDate, m = e.onMonthChange, n = e.activeDate, d = e.monthChangeDirection, g = e.onMonthSelect, h = e.onYearSelect, c = e.isMonthSelectorOpen, S = e.isYearSelectorOpen, j = e.locale, R = e.selectorStartingYear, W = e.selectorEndingYear, I = ee(null), M = ee(null), s = pe(j), p = s.getMonthName, D = s.isBeforeDate, f = s.getLanguageDigits, P = pa("DatePicker"), L = P.t;
  ne(function() {
    d && Ke({
      direction: d,
      parent: M.current
    });
  }, [d]), ne(function() {
    var v, C = c || S, b = I == null || (v = I.current) == null ? void 0 : v.querySelector(".Calendar__monthYear.-shown .Calendar__monthText"), E = b == null ? void 0 : b.nextSibling, Y = function(ie) {
      return ie.classList.contains("-activeBackground");
    }, B = !C && !Y(b) && !Y(E);
    if (!B) {
      var ce = c || Y(b), Z = ce ? b : E, se = ce ? E : b;
      Z == null || Z.classList.toggle("selected"), Z == null || Z.classList.toggle("-activeBackground"), se.classList.toggle("notSelected");
    }
  }, [c, S]);
  var z = function(C) {
    var b = je({
      isInitialActiveChild: C,
      monthChangeDirection: d,
      activeDate: n,
      parent: M.current
    }), E = f(b.year), Y = p(b.month);
    return {
      month: Y,
      year: E
    };
  }, K = r && D(r, Object.assign({}, n, {
    month: n.month + 1,
    day: 1
  })) || n.year === W && n.month === 12, q = i && (D(Object.assign({}, n, {
    day: 1
  }), i) || $(i, Object.assign({}, n, {
    day: 1
  }))) || n.year === R && n.month === 1, T = function(C) {
    var b, E, Y = Array.from((b = M == null || (E = M.current) == null ? void 0 : E.children) != null ? b : []).some(function(B) {
      return B.classList.contains("-shownAnimated");
    });
    Y || m(C);
  }, X = function() {
    S || g();
  }, Q = function() {
    c || h();
  };
  ne(function() {
    if (c) {
      var v = document.querySelector(".Calendar__monthSelectorItem.-active"), C = v == null ? void 0 : v.querySelector("button");
      C && setTimeout(function() {
        C.focus();
      }, 100);
    }
    if (S) {
      var b = document.querySelector(".Calendar__yearSelectorItem.-active"), E = b == null ? void 0 : b.querySelector("button");
      E && setTimeout(function() {
        E.focus();
      }, 100);
    }
  }, [c, S]);
  var H = function(C) {
    (C.code === "Enter" || C.code === "Space") && (C.preventDefault(), X());
  }, F = function(C) {
    (C.code === "Enter" || C.code === "Space") && (C.preventDefault(), Q());
  }, oe = [!0, !1].map(function(v) {
    var C = z(v), b = C.month, E = C.year, Y = b === p(n.month);
    return /* @__PURE__ */ re(xa, {
      onAnimationEnd: De,
      className: te(["Calendar__header-monthYearWrapper", "Calendar__monthYear", v ? "-shown" : "-hiddenNext"]),
      role: "presentation",
      "aria-hidden": !Y,
      children: [/* @__PURE__ */ _(Oe, {
        onClick: function() {
          X();
        },
        variant: "tertiary",
        className: "Calendar__header-Button Calendar__monthText",
        onKeyDown: H,
        tabIndex: Y && v ? 0 : -1,
        "aria-label": c ? "Month Selector" : b + ", Click here to " + L("Open Month Selector"),
        "tab-index": Y && v ? 0 : -1,
        "aria-expanded": !!c,
        "aria-hidden": !Y,
        children: b
      }), /* @__PURE__ */ _(Oe, {
        onClick: function() {
          Q();
        },
        tabIndex: Y && v ? 0 : -1,
        variant: "tertiary",
        className: "Calendar__header-Button Calendar__yearText",
        "aria-label": S ? L("Year Selector", "yearSelector") : E + ", Click here to " + L("Open Year Selector", "openYearSelector"),
        "tab-index": Y && v ? 0 : -1,
        "aria-expanded": !!S,
        "aria-hidden": !Y,
        onKeyDown: F,
        children: E
      })]
    }, String(v));
  }), J = c || S;
  return /* @__PURE__ */ _("div", {
    role: "row",
    children: /* @__PURE__ */ re(wa, {
      ref: I,
      className: "Calendar__header",
      role: "gridcell",
      children: [/* @__PURE__ */ _(Ie, {
        className: te(["Calendar__header-iconButton", {
          "Calendar__header-iconButton--hidden": J
        }]),
        icon: "caretLeft",
        size: "medium",
        "aria-hidden": !!J,
        "tab-index": J ? -1 : 0,
        "aria-label": L("Previous Month", "previousMonth"),
        "aria-disabled": q,
        variant: "tertiary",
        onClick: function() {
          T("PREVIOUS");
        },
        type: "button",
        disabled: q
      }), /* @__PURE__ */ re(Na, {
        className: "Calendar__header-monthYearContainer",
        ref: M,
        "data-testid": "month-year-container",
        children: [" ", oe]
      }), /* @__PURE__ */ _(Ie, {
        className: te(["Calendar__header-iconButton"]),
        icon: J ? "cancelClose" : "caretRight",
        size: "medium",
        variant: J ? "ghost" : "tertiary",
        onClick: function() {
          c ? g() : S ? h() : T("NEXT");
        },
        "aria-label": J ? L("Clear Button", "clearButton") : L("Next Month", "nextMonth"),
        "aria-disabled": K,
        type: "button",
        disabled: K
      })]
    })
  });
}, Ya = /* @__PURE__ */ N.div.withConfig({
  displayName: "MonthSelector__StyledCalendarMonthSelectorAnimationWrapper",
  componentId: "nft5u-0"
})(["&.Calendar__monthSelectorAnimationWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorAnimationWrapper);
}), Aa = /* @__PURE__ */ N.div.withConfig({
  displayName: "MonthSelector__StyledCalendarMonthSelectorWrapper",
  componentId: "nft5u-1"
})(["&.Calendar__monthSelectorWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorWrapper);
}), La = /* @__PURE__ */ N.ul.withConfig({
  displayName: "MonthSelector__StyledCalendarMonthSelector",
  componentId: "nft5u-2"
})(["&.Calendar__monthSelector{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelector);
}), Ta = /* @__PURE__ */ N.li.withConfig({
  displayName: "MonthSelector__StyledCalenderMonthSelectorItem",
  componentId: "nft5u-3"
})(["&.Calendar__monthSelectorItem{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalenderMonthSelectorItem);
}), Ea = /* @__PURE__ */ N.button.withConfig({
  displayName: "MonthSelector__StyledCalendarMonthSelectorItemText",
  componentId: "nft5u-4"
})(["&.Calendar__monthSelectorItemText{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorText);
}), vt = function(e) {
  var r = e.activeDate, i = e.maximumDate, m = e.minimumDate, n = e.onMonthSelect, d = e.isOpen, g = e.locale, h = ee(null), c = ee(null);
  ne(function() {
    var p, D, f = d ? "add" : "remove";
    (p = c.current) == null || p.classList[f]("-open"), (D = h.current) == null || D.classList[f]("-open");
  }, [d]);
  var S = pe(g), j = S.getMonthNumber, R = S.isBeforeDate, W = Ve(g), I = W.months, M = function(D) {
    be(D, {
      allowVerticalArrows: !0
    });
  }, s = function() {
    return I.map(function(D) {
      var f = j(D), P = {
        day: 1,
        month: f,
        year: r.year
      }, L = i && R(i, Object.assign({}, P, {
        month: f
      })), z = m && (R(Object.assign({}, P, {
        month: f + 1
      }), m) || $(Object.assign({}, P, {
        month: f + 1
      }), m)), K = f === r.month;
      return /* @__PURE__ */ _(Ta, {
        className: "Calendar__monthSelectorItem " + (K ? "-active" : ""),
        children: /* @__PURE__ */ _(Ea, {
          tabIndex: K && d ? 0 : -1,
          onClick: function() {
            n(f);
          },
          className: "Calendar__monthSelectorItemText",
          type: "button",
          disabled: L || z,
          "aria-pressed": K,
          "data-is-default-selectable": K,
          children: D.substring(0, 3)
        })
      }, D);
    });
  };
  return /* @__PURE__ */ _(Ya, {
    role: "presentation",
    ref: c,
    className: "Calendar__monthSelectorAnimationWrapper",
    "aria-hidden": !d,
    children: /* @__PURE__ */ _(Aa, {
      role: "presentation",
      "data-testid": "month-selector-wrapper",
      className: "Calendar__monthSelectorWrapper",
      onKeyDown: M,
      children: /* @__PURE__ */ _(La, {
        ref: h,
        className: te(["Calendar__monthSelector", "monthSelector"]),
        "data-testid": "month-selector",
        children: s()
      })
    })
  });
}, Ra = /* @__PURE__ */ N.div.withConfig({
  displayName: "YearSelector__StyledCalendarYearSelectorAnimationWrapper",
  componentId: "iuk1kb-0"
})(["&.Calendar__yearSelectorAnimationWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorAnimationWrapper);
}), Wa = /* @__PURE__ */ N.div.withConfig({
  displayName: "YearSelector__StyledCalendarYearSelectorWrapper",
  componentId: "iuk1kb-1"
})(["&.Calendar__yearSelectorWrapper{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorWrapper);
}), Ia = /* @__PURE__ */ N.ul.withConfig({
  displayName: "YearSelector__StyledCalendarYearSelector",
  componentId: "iuk1kb-2"
})(["&.Calendar__yearSelector{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelector);
}), Oa = /* @__PURE__ */ N.li.withConfig({
  displayName: "YearSelector__StyledCalendarYearSelectorItem",
  componentId: "iuk1kb-3"
})(["&.Calendar__yearSelectorItem{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarYearSelectorItem);
}), Pa = /* @__PURE__ */ N.button.withConfig({
  displayName: "YearSelector__StyledCalendarYearSelectorText",
  componentId: "iuk1kb-4"
})(["&.Calendar__yearSelectorText{", ";}"], function(t) {
  var e = t.theme.components.datePicker;
  return x(e.StyledCalendarSelectorText);
}), yt = function(e) {
  for (var r = e.isOpen, i = e.activeDate, m = e.onYearSelect, n = e.selectorStartingYear, d = n === void 0 ? 0 : n, g = e.selectorEndingYear, h = g === void 0 ? 0 : g, c = e.maximumDate, S = e.minimumDate, j = e.locale, R = ee(null), W = ee(null), I = ee(null), M = pe(j), s = M.getLanguageDigits, p = M.getToday, D = d || p().year - ga, f = h || p().year + Sa, P = [], L = D; L <= f; L += 1)
    P.push(L);
  ne(function() {
    var q, T, X, Q, H = r ? "add" : "remove", F = (q = R.current) == null ? void 0 : q.querySelector(".Calendar__yearSelectorItem.-active");
    F || console.log("Provided value for year is out of selectable year range. You're probably using a wrong locale prop value or your provided value's locale is different from the date picker locale. Try changing the 'locale' prop or the value you've provided."), (T = I.current) == null || T.classList[H]("-open"), (X = R.current) == null || X.classList[H]("-faded"), F && W.current && (W.current.scrollTop = (F == null ? void 0 : F.offsetTop) - (F == null ? void 0 : F.offsetHeight) * 5), (Q = W.current) == null || Q.classList[H]("-open");
  }, [r]);
  var z = function() {
    return P.map(function(T) {
      var X = c && T > c.year, Q = S && T < S.year, H = i.year === T;
      return /* @__PURE__ */ _(Oa, {
        className: te(["Calendar__yearSelectorItem", {
          "-active": H
        }]),
        children: /* @__PURE__ */ _(Pa, {
          tabIndex: H && r ? 0 : -1,
          className: "Calendar__yearSelectorText",
          type: "button",
          onClick: function() {
            m(T);
          },
          disabled: X || Q,
          "aria-pressed": H,
          "data-is-default-selectable": H,
          children: s(T)
        })
      }, T);
    });
  }, K = function(T) {
    be(T, {
      allowVerticalArrows: !1
    });
  };
  return /* @__PURE__ */ _(Ra, {
    className: "Calendar__yearSelectorAnimationWrapper",
    ref: I,
    role: "presentation",
    "aria-hidden": !r,
    children: /* @__PURE__ */ _(Wa, {
      ref: R,
      className: "Calendar__yearSelectorWrapper",
      role: "presentation",
      "data-testid": "year-selector-wrapper",
      onKeyDown: K,
      children: /* @__PURE__ */ _(Ia, {
        ref: W,
        className: "Calendar__yearSelector",
        "data-testid": "year-selector",
        children: z()
      })
    })
  });
};
export {
  mt as D,
  ht as H,
  vt as M,
  yt as Y,
  Ve as a,
  pe as u
};
